import { getIconRenderer } from './getIconRenderer';
import { IFeatureProperties } from '../../../../../types/map';

export function getIcons({ isActive, offers }: IFeatureProperties): string {
  const { isViewed, isFavorite, icon } = offers[0] || {};
  const iconProps = { isViewed, isActive };

  if (isFavorite) {
    return getIconRenderer('favorite', iconProps);
  }

  return icon ? getIconRenderer(icon, iconProps) : '';
}
